<div class="suporte-geral-edit">
  <header class="mb-4">
    <h2 class="h2-edit">Suporte Local - {{ actionLabel }}</h2>
  </header>
  <ng-container [ngSwitch]="type" *ngIf="type == 'create' || data?.id">
    <app-edit-form *ngSwitchDefault
      [formData]="formData" [data]="data" [canDelete]="false" 
      (saveData)="save($event)">
    <button class="btn btn-red-1 m-r-xs" type="button" *ngIf="!data.suporte_geral_solicitado" (click)="sendToAdmin()">Suporte SPGG</button>
    <button class="btn btn-green-1 m-r-xs" type="button" (click)="sendMessage()">Enviar</button>
    </app-edit-form>
  </ng-container>
</div>
<app-loading [loader]="isLoading"></app-loading>

